export const headerConstants = {
  REGISTER_MENU_TOGGLER: 'HEADER_REGISTER_MENU_TOGGLER',
  CLEAR_MENU_TOGGLER: 'HEADER_CLEAR_MENU_TOGGLER'
};
